import React, { useState, useRef } from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router";
import { Severty, ShowToast } from "../../helper/toast";

const OtpVerification = () => {
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef([]);
  const Navigate = useNavigate();
  const { verifyOtp, forgetPassword } = useAuth();
  const location = useLocation();
  const { data } = location.state || {};

  const handleChange = (value, index) => {
    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    // Focus next input if value entered
    if (value && index < inputRefs.current.length - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    // Handle backspace: go to previous input
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };

  const handleFinish = async () => {
    try {
      const finalOtp = otp.join("");
      const response = await verifyOtp({
        otp: finalOtp,
        email: data.email,
        phone: data.phone,
        countryCode: data.countryCode,
        type: data.type,
      });
      if (response.status === 200) {
        if (data.type === "signup") {
          Navigate("/home");
        } else {
          Navigate("/reset-password", { state: { data } });
        }
      }
      // Trigger your verification logic here
    } catch (error) {
      console.error("Error verifying OTP:", error);
      ShowToast(error.message, Severty.ERROR);
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await forgetPassword(data);
      if (response.status === 200) {
        ShowToast("OTP re-sent successfully", Severty.SUCCESS);
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      // ShowToast("Error occured when re-sent otp", Severty.ERROR);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h4 className="signup-title">Enter OTP</h4>
        <p className="signup-subtitle">
          Enter the OTP code we just sent you on your registered Email/Phone
          number
        </p>

        <Form layout="vertical" onFinish={handleFinish} requiredMark={false}>
          <Form.Item className="mb-5">
            <div
              style={{ display: "flex", justifyContent: "center", gap: "12px" }}
            >
              {otp.map((digit, index) => (
                <Input
                  key={index}
                  maxLength={1}
                  value={digit}
                  onChange={(e) => {
                    const value = e.target.value;

                    // allow only digits
                    if (/^\d$/.test(value)) {
                      handleChange(value, index);
                    } else if (value === "") {
                      handleChange("", index); // allow backspace clear
                    }
                    // ignore spaces and letters
                  }}
                  onKeyDown={(e) => {
                    if (e.key === " " || e.key === "Spacebar") {
                      e.preventDefault(); // block space
                    }
                    handleKeyDown(e, index);
                  }}
                  ref={(el) => (inputRefs.current[index] = el)}
                  style={{
                    width: "57px",
                    height: "57px",
                    fontSize: "18px",
                    textAlign: "center",
                  }}
                />
              ))}
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              className="Fill-button"
              // onClick={() => Navigate("/reset-password")}
            >
              {data && data.type === "signup" ? "Verify" : " Reset Password"}
            </Button>
          </Form.Item>
          <div className="signin-text">
            Didn’t get OTP? <span onClick={handleResendOtp}>Resend OTP</span>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default OtpVerification;
